import script from "./PromoListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromoListItem.vue?vue&type=script&setup=true&lang=ts"

import "./PromoListItem.vue?vue&type=style&index=0&id=d0de7b16&lang=scss"

const __exports__ = script;

export default __exports__